import LoginService from "./LoginService"
import APIconsume from './APIconsume'
import { decodeToken,
    getAccessToken,
    getRefreshToken,
    removeUserSession,
    setAccessToken
} from "./../Variables/Common"



class UserService extends LoginService {
    constructor() {
        super()
        const accessToken = getAccessToken()
        this._url = 'User'
        this._path = '/auth/'
        this._consume = new APIconsume(accessToken)
    }

    async getUser(name) {
        if (!name) {
            const {username} = decodeToken(this.accessToken)
            const result = await this._consume.getData(`${this._url}/${username}`)
            return result.data
        } else {
            const result = await this._consume.getData(`${this._url}/${name}`)
            return result.data
        }
    }

    async register(payload) {
        const url = `/register`
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async registerNew(payload) {
        const url = `/register/new`
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async getMitraLocation() {
        const url = `select/location`
        const result = await this._consume.getData(url)
        return result.data
    }

    async renewApiToken(payload) {
        const url = `${this._path}renew-token`
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async refreshUser (token) {
        const url = `${this._path}Refresh`
        const payload = { refreshToken: token }
        const result = await this._consume.putData(payload, url)
        const accessToken = result.data.data.accesstoken
        setAccessToken(accessToken)
        return result
    }

    async getTwoFaQrCode() {
        const url = `auth/2fa/qr`
        const result = await this._consume.getData(url)
        return result.data
    }

    async setTwoFA(payload) { // useQauth, otp
        const url = `auth/2fa`
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async checkTwoFA(payload) { // email
        const url = `auth/2fa/check`
        const result = await this._consume.postData(payload, url)
        return result.data
    }

    async LogOut () {
        const url = `${this._path}logout`
        const refreshToken = getRefreshToken()
        const payload = {
            refreshToken: refreshToken
        }

        removeUserSession()
        const result = await this._consume.postData(payload, url)
        return result.data
    }
}

export default UserService